import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../pages/constants';

const ListSkeleton = (props) => {
  const { width, height } = props;
  return (
    <ContentLoader viewBox="10 0 430 124">
      <rect x="10" y="0" rx="4" ry="4" width={width} height={height} />
      <rect x="10" y="20" rx="4" ry="4" width={width} height={height} />
      <rect x="10" y="40" rx="4" ry="4" width={width} height={height} />
      <rect x="10" y="60" rx="4" ry="4" width={width} height={height} />
      <rect x="10" y="80" rx="4" ry="4" width={width} height={height} />
    </ContentLoader>
  );
};

export default ListSkeleton;

ListSkeleton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ListSkeleton.defaultProps = {
  width: LIST_SKELETON_WIDTH,
  height: LIST_SKELETON_HEIGHT,
};
